import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/arrow.svg'


const _hoisted_1 = { class: "my-1" }
const _hoisted_2 = { class: "w-full aspect-w-1 aspect-h-1" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]

import { ref, watch, onMounted } from 'vue';
import { Carousel, Slide } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';

interface Props {
  images: string[];
}


export default /*#__PURE__*/_defineComponent({
  props: {
    images: null
  },
  setup(__props: any) {



const imageSelectIndex = ref<number>(0);
const imagesRef = ref<typeof Carousel>();

watch(imageSelectIndex, (val) => {
  imagesRef.value?.slideTo(val);
});

onMounted(() => {
  imagesRef.value?.slideTo(0);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: __props.images[imageSelectIndex.value],
          alt: "",
          class: "w-full h-full object-cover"
        }, null, 8, _hoisted_3)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Carousel), {
        "items-to-show": 5,
        "items-to-scroll": imageSelectIndex.value,
        "wrap-around": false,
        ref_key: "imagesRef",
        ref: imagesRef
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.images, (img, i) => {
            return (_openBlock(), _createBlock(_unref(Slide), {
              key: `images-${i}`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "w-full p-1 cursor-pointer",
                  onClick: ($event: any) => (imageSelectIndex.value = i)
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full aspect-w-1 aspect-h-1", { 'border-4 border-primary': imageSelectIndex.value == i }])
                  }, [
                    _createElementVNode("img", {
                      src: img,
                      class: "w-full h-full object-cover",
                      alt: "gallery"
                    }, null, 8, _hoisted_6)
                  ], 2)
                ], 8, _hoisted_5)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["items-to-scroll"]),
      _createElementVNode("div", {
        class: _normalizeClass(["absolute left-2 top-1/2 -mt-3 w-6 h-6 rounded-full p-2 cursor-pointer", {
          'bg-gray-200': imageSelectIndex.value == 0,
          'bg-primary ': imageSelectIndex.value != 0,
        }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
          imageSelectIndex.value = imageSelectIndex.value < 1 ? 0 : imageSelectIndex.value - 1
        ))
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: _normalizeClass(["w-4", {
            'opacity-25': imageSelectIndex.value == 0,
            'filter invert': imageSelectIndex.value != 0,
          }]),
          alt: "arrow"
        }, null, 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["absolute right-2 top-1/2 -mt-3 w-6 h-6 rounded-full p-2 cursor-pointer", {
          'bg-gray-200': imageSelectIndex.value == __props.images.length - 1,
          'bg-primary f': imageSelectIndex.value != __props.images.length - 1,
        }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (
          imageSelectIndex.value =
            imageSelectIndex.value >= __props.images.length - 1
              ? __props.images.length - 1
              : imageSelectIndex.value + 1
        ))
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: _normalizeClass(["transform rotate-180", {
            'opacity-25': imageSelectIndex.value == __props.images.length - 1,
            'filter invert ': imageSelectIndex.value != __props.images.length - 1,
          }]),
          alt: "arrow"
        }, null, 2)
      ], 2)
    ])
  ]))
}
}

})